<template>
	<!-- Vue Material Toolbar -->
	<!-- https://vuematerial.io/components/toolbar -->

	<md-toolbar
		:class="{
			'md-dense': dense
		}"
		class="ui-toolbar md-primary"
	>
		<slot/>
	</md-toolbar>
</template>

<script>
export default {
	name: "Toolbar",
	props: {
		dense: {
			type: Boolean,
			default: false,
			required: false
		}
	}
};
</script>

<style lang="scss" scoped>
.ui-toolbar {
	padding: 0 15px;
}
</style>
